import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-timeline-transport-edit-order-modal',
    templateUrl: './timeline-transport-edit-order-modal.component.html',
    styleUrls: ['./timeline-transport-edit-order-modal.component.scss'],
    standalone: false
})
export class TimelineTransportEditOrderModalComponent implements OnInit, OnChanges {

  @Input()
  isLoaded: boolean = false;
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.isLoaded) {
      this.isLoaded = true;
    }
  }

  ngOnInit(): void {
  }

}
